/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_License_Row_Per_ScopeInputs */

const es_marketplace_seo_license_row_per_scope = /** @type {(inputs: Marketplace_Seo_License_Row_Per_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navegación diurna hasta 12 millas de la costa.`)
};

const gl_marketplace_seo_license_row_per_scope = /** @type {(inputs: Marketplace_Seo_License_Row_Per_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navegación diurna ata 12 millas da costa.`)
};

const en_marketplace_seo_license_row_per_scope = /** @type {(inputs: Marketplace_Seo_License_Row_Per_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Day navigation up to 12 miles from the coast.`)
};

/**
* | output |
* | --- |
* | "Day navigation up to 12 miles from the coast." |
*
* @param {Marketplace_Seo_License_Row_Per_ScopeInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_license_row_per_scope = /** @type {((inputs?: Marketplace_Seo_License_Row_Per_ScopeInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_License_Row_Per_ScopeInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_license_row_per_scope(inputs)
	if (locale === "en") return en_marketplace_seo_license_row_per_scope(inputs)
	return es_marketplace_seo_license_row_per_scope(inputs)
});